import { render, staticRenderFns } from "./SocialShare_component.vue?vue&type=template&id=1cd0bd17&"
import script from "./SocialShare_component.vue?vue&type=script&lang=js&"
export * from "./SocialShare_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports